import type { Product } from '../types';
import styles from './ProductCard.module.css';

interface ProductCardProps {
    product: Product;
    onClick?: () => void;
    showScore?: boolean;
}

export function ProductCard({ product, onClick, showScore }: ProductCardProps) {
    const placeholderImage = `https://via.placeholder.com/300x200/1a1a2e/8b5cf6?text=${encodeURIComponent(product.brand || 'No Image')}`;

    return (
        <div className={styles.card} onClick={onClick}>
            <img
                className={styles.image}
                src={product.image_url || placeholderImage}
                alt={product.parfum_name}
                onError={(e) => {
                    (e.target as HTMLImageElement).src = placeholderImage;
                }}
            />
            <div className={styles.info}>
                <p className={styles.brand}>{product.brand}</p>
                <h3 className={styles.name}>{product.parfum_name}</h3>
                <p className={styles.notes}>{product.notes}</p>
                <div className={styles.tags}>
                    {product.gender && <span className={styles.tag}>{product.gender}</span>}
                    {product.category && <span className={styles.tag}>{product.category}</span>}
                    {showScore && product.match_score && (
                        <span className={styles.scoreTag}>{product.match_score}% Match</span>
                    )}
                </div>
                {product.price && (
                    <p className={styles.price}>Rp {Number(product.price).toLocaleString('id-ID')}</p>
                )}
            </div>
        </div>
    );
}
